// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: 'rgb(24, 26, 71)', // Your custom blue
      contrastText: '#fff',
    },
    error: {
      main: 'rgb(149,6,6)', // Replace this with your desired red
      contrastText: '#fff', // Optional, for buttons and text contrast
    },
    success: {
      main: 'rgb(46,111,64)', // Dark green for success
      contrastText: '#fff', // Optional
    },
  },
});

export default theme;
